<template>
    <list-manager
        class="pages-periodical-data"
        :dataUrl="'/periodicalList'"
        :statusUrl="'/status/Periodical'"
        :tableScroll="{x: 1800, y: 'max-content'}"
        :columns="columns"
        :showPage="true"
        :showExportBtn="false"
        :showViewBtn="false"
        :showEditBtn="false"
    >
        <template v-slot:top-ctrl-left></template>
        <template v-slot:bottom-ctrl-left></template>
        <template v-slot:right-btns>
            <a-button type="primary" @click.stop="importData">
                <template v-slot:icon>
                    <cigo-icon-font class="btn-icon" :name="'cigoadmin-icon-daoru'"></cigo-icon-font>
                </template>
                导入数据
            </a-button>
        </template>
    </list-manager>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import dayjs from "dayjs";
import CigoIconFont from "@/components/cigo-ui/unit/basic/cigo-icon-font.vue";
import ListManager from "@/components/cigo-admin-core/pages/template/ListManager.vue";
import ImportExcelData from "@/components/cigo-ui/unit/other/ImportExcelData.vue";
import cigoLayer from "@/components/cigo-layer";
import { apiErrorCatch, apiRequest, apiSign } from "@/common/http";

export default defineComponent({
    name: "PeriodicalDataMg",
    components: {
        CigoIconFont,
        ListManager
    },
    setup(props) {
        const columns = [
            {
                title: "编号",
                dataIndex: "id",
                width: "80px"
            },
            {
                title: "期刊英文名",
                dataIndex: "name_en"
                // width: "300px",
            },
            {
                title: "期刊中文名",
                dataIndex: "name_cn"
                // width: "300px"
            },
            {
                title: "ISSN",
                dataIndex: "issn",
                width: "180px"
            },
            {
                title: "中科院分区",
                dataIndex: "area",
                width: "130px"
            },
            {
                title: "SCI/SCIE",
                dataIndex: "sci",
                width: "130px"
            },
            {
                title: "IF(2017)",
                dataIndex: "factor_2017",
                width: "120px"
            },
            {
                title: "IF(2018)",
                dataIndex: "factor_2018",
                width: "120px"
            },
            {
                title: "IF(2019)",
                dataIndex: "factor_2019",
                width: "120px"
            },
            {
                title: "学科分类",
                dataIndex: "category",
                width: "120px"
            },
            {
                title: "创建时间",
                dataIndex: "create_time",
                width: "250px"
            }
        ];

        const importData = () => {
            cigoLayer.component({
                component: ImportExcelData,
                width: "1000px",
                height: "700px",
                maskClose: false,
                layerData: {
                    title: "导入期刊数据",
                    columnsNameMap: new Map([
                        ["name_cn", "中文名"],
                        ["name_en", "英文名"],
                        ["issn", "ISSN"],
                        ["area", "中科院分区"],
                        ["sci", "SCI/SCIE"],
                        ["factor_2017", "2017影响因子"],
                        ["factor_2018", "2018影响因子"],
                        ["factor_2019", "2019影响因子"],
                        ["site", "官网地址"],
                        ["doc_link", "文献地址"],
                        ["category", "学科分类"],
                    ]),
                    tableScroll: {
                        x: 2000,
                        y: "max-content"
                    }
                },
                notify: (
                    flag: string,
                    dataList: any,
                    resolve: any,
                    reject: any
                ) => {
                    if (flag == "ok") {
                        //TODO 增加加载中动画
                        cigoLayer.confirm({
                            layerData: {
                                msg: "将会清空原有期刊数据，确定导入吗？",
                                showCancel: true
                            },
                            ok: () => {
                                doImport(dataList, resolve, reject);
                            }
                        });
                    }
                }
            });
        };

        const doImport = (dataList: any, resolve: any, reject: any) => {
            let params: any = {
                dataList: dataList
            };
            apiRequest.v1
                .post("/importPeriodical", params, {
                    headers: apiSign(params)
                })
                .then(response => {
                    cigoLayer.msg(response.data.msg);
                    resolve();
                })
                .catch(apiErrorCatch.v1);
        };

        return {
            dayjs,
            columns,
            importData
        };
    }
});
</script>

<style lang="scss">
</style>
